import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, ShoppingBag, User } from 'lucide-react';
import { triggerHaptic } from '../utils/haptics';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: '/', icon: Home, label: 'Меню' },
    { path: '/cart', icon: ShoppingBag, label: 'Корзина' },
    { path: '/profile', icon: User, label: 'Профиль' },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-tg-bg border-t border-gray-100/10 pb-safe pt-2 px-6 flex justify-between items-center z-40 backdrop-blur-md bg-opacity-95 h-[80px]">
      {navItems.map((item) => {
        const isActive = location.pathname === item.path;
        const Icon = item.icon;
        
        return (
          <button
            key={item.path}
            onClick={() => {
              if (!isActive) {
                triggerHaptic('light');
                navigate(item.path);
              }
            }}
            className={`flex flex-col items-center justify-center w-16 transition-colors duration-200 ${
              isActive ? 'text-tg-button' : 'text-tg-hint hover:text-tg-text'
            }`}
          >
            <Icon 
              size={24} 
              strokeWidth={isActive ? 2.5 : 2} 
              className={`mb-1 transition-transform ${isActive ? 'scale-110' : ''}`}
            />
            <span className="text-[10px] font-medium">{item.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default BottomNav;
